<template>
  <div>
    <div class="text-center depahead rsu">History List</div>
    <div style="max-width: 500px; margin-left: auto; margin-right: auto">
      <v-layout row wrap justify-end>
        <div
          class="submitbtn"
          style="width: 170px;margin-left: 0;margin-right: auto;"
        >
          <v-btn
            text
            @click="gotoHistoryList"
            class="text-capitalize"
            color="primary"
            block
            >< ย้อนกลับ</v-btn
          >
        </div>
      </v-layout>
      <v-layout column class="mt-4">
        <v-layout
          class="mt-8"
          row
          wrap
          v-for="(item, index) in mainData"
          :key="`mainDataProject-${index}`"
        >
          <v-flex xs3 sm4>
            <div class="flex-all-center">
              <img style="width: 100%; height: auto;" :src="item.projectimg" />
            </div>
          </v-flex>
          <v-flex xs9 sm8>
            <h4>{{ item.projectname }}</h4>
            <div>
              {{
                item.projectdesc.length > lengthHide
                  ? `${item.projectdesc.substring(0, lengthHide)}...`
                  : item.projectdesc
              }}
            </div>
            <v-btn @click="seeproject(item)" class="col-12 mt-3" color="primary"
              >ดูรายละเอียดข้อมูลการสมัคร</v-btn
            >
          </v-flex>
        </v-layout>
      </v-layout>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  components: {},
  data() {
    return {
      loading: false,
      logoutloading: false,
      mainData: null,
      lengthHide: 150,
    };
  },
  async mounted() {
    // this.getProfile();
    this.mainData = await this.depacheckmemberinfo();
  },
  computed: {
    data() {
      return this.$store.state.profiledata;
    },
    memberid() {
      return this.$store.state.memberid;
    },
    membertype() {
      if (
        this.data.verification == "บุคคลธรรมดา" ||
        this.data.verification == "เกษตรกร"
      ) {
        return Regular;
      } else if (this.data.verification == "มี Tax ID") {
        return TaxID;
      } else if (this.data.membertype == "มหาวิทยาลัย") {
        return University;
      } else {
        return NoTaxID;
      }
    },
  },
  methods: {
    seeproject(data) {
      //   console.log(data);   tsmp    first
      this.$router.replace({
        query: {
          view: "CustomForm",
          apptype: "line",
          pageid: "DEPA",
          projectid: data.projectid,
          mode: "readonly",
          applicantid: data.id,
          member_id: data.memberid,
          first: false,
          tsmp: new Date().getTime(),
        },
      });
      this.$store.state.query = {
        view: "CustomForm",
        apptype: "line",
        pageid: "DEPA",
        projectid: data.projectid,
        mode: "readonly",
        applicantid: data.id,
        member_id: data.memberid,
        first: false,
        tsmp: new Date().getTime(),
      };
    },
    gotoHistoryList() {
      this.$store.state.query.view = "Profile";
    },
    depacheckmemberinfo() {
      return new Promise((resolve) => {
        axios
          .get(this.serverUrl + `depaApplyProjectByMemberId/${this.memberid}`, {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          })
          .then(async (response) => {
            if (response.data.responsecode == 200) {
              resolve(response.data.data);
            } else {
              resolve(null);
            }
          });
      });
    },
  },
};
</script>

<style lang="scss">
.titleprofile {
  color: grey !important;
  font-size: 12px;
}
.subprofile {
  line-height: 12px;
  font-size: 17px;
  margin-bottom: 10px;
  font-weight: 500;
}
</style>
